import api from './api';
import type { BcraCentralDeudoresConsulta } from '../types/bcraCentralDeudores';

const bcraService = {
  consultarCentralDeudores: async (cuit: string): Promise<BcraCentralDeudoresConsulta> => {
    const response = await api.get<BcraCentralDeudoresConsulta>(
      `/api/Bcra/central-deudores/${encodeURIComponent(cuit)}`
    );
    return response.data;
  },
};

export default bcraService;
